import { Link } from "react-router-dom";
import { services } from "@/mocks/homeData";

export default function Services() {
  return (
    <section id="servicios" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-bold tracking-wide uppercase mb-4">
            Nuestros Servicios
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Soluciones integrales que tu espacio necesita
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Desde la venta del equipo hasta el soporte postventa. Un solo proveedor,
            cero complicaciones.
          </p>
        </div>

        {/* Service Cards */}
        <div className="space-y-12 md:space-y-16">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`reveal grid md:grid-cols-2 gap-6 md:gap-10 items-center ${
                index % 2 === 1 ? "md:direction-rtl" : ""
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? "md:order-2" : ""}`}>
                <div className="relative rounded-2xl overflow-hidden group">
                  {service.video ? (
                    <video
                      src={service.video}
                      poster={service.image}
                      muted
                      loop
                      playsInline
                      autoPlay
                      className="w-full h-64 md:h-80 object-cover"
                    />
                  ) : (
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-64 md:h-80 object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent" />
                  <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6">
                    <div className="w-12 h-12 rounded-xl bg-background-50/90 backdrop-blur-sm flex items-center justify-center shadow-lg">
                      <i className={`${service.icon} text-primary-600 text-xl`} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? "md:order-1 md:text-right" : ""}`}>
                <span className="inline-block text-xs font-bold tracking-wide uppercase text-accent-600 mb-2">
                  {service.subtitle}
                </span>
                <h3 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
                  {service.title}
                </h3>
                {service.description ? (
                  <p className="text-foreground-600 text-base leading-relaxed mb-4">
                    {service.description}
                  </p>
                ) : null}
                {service.listTitle ? (
                  <p className="font-heading font-semibold text-foreground-900 text-base mb-3 text-left">
                    {service.listTitle}
                  </p>
                ) : null}
                {service.bullets ? (
                  <ul className="space-y-2.5 mb-6 text-left">
                    {service.bullets.map((bullet, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-3 text-foreground-600 text-sm md:text-base leading-relaxed"
                      >
                        <span className="w-6 h-6 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-check-line text-sm" />
                        </span>
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                ) : null}
                <a
                  href="https://wa.link/b002hg"
                  className="flex w-fit mx-auto items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  {service.cta}
                  <i className="ri-arrow-right-line" />
                </a>
                {service.path && (
                  <Link
                    to={service.path}
                    className="block mt-3 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    Conocer más sobre este servicio
                    <i className="ri-arrow-right-line ml-1.5" />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}